import React, { useMemo, useState } from "react";
import "./ShopByCategory.css";

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useSearch } from "../SearchContext";
 

import ProductCard from "../Product/ProductCard";

const categories = [
  {
    id: "dryfruits",
    name: "Dryfruits",
    image: require("../images/dryfruit.webp"),
  },
  {
    id: "fruits",
    name: "Fruits",
    image: require("../images/fruits.jpg"),
  },
  {
     id: "beverages", 
     name: "Beverages",
      image: require("../images/juice.jpg") 
  },
  { 
    id: "snacks", 
    name: "Snacks",
     image: require("../images/snacks.jpg") 
  },
  {
    id: "homecare",
    name: "Home Care",
    image: require("../images/homecare.webp"),
  },
  { id: "dairy", 
    name: "Dairy", 
    image: require("../images/diary.jpg") 
  },
  {
    id: "vegitables",
    name: "Vegetables",
    image: require("../images/vegis.jpg"),
  },
  {
    id: "rice",
    name: "Rice ",
    image: require("../images/rice.jpg"),
  },
  {
    id: "personalcare",
    name: "Personal Care",
    image: require("../images/Personalcare.jpeg"),
  },
  { 
    id: "baby", 
    name: "Baby Care", 
    image: require("../images/baby.jpg") },
  {
    id: "chocolate",
    name: "Chocolate",
    image: require("../images/choco.webp"),
  },
  {
     id: "biscuts", 
     name: "Biscuits", 
     image: require("../images/cookie.webp") 
    },
  // { 
  //   id: "oil",
  //    name: "Oil", 
  //    image: require("../images/oils.jpg") },
  {
    id: "herbs&spices",
    name: "Herbs & spices",
    image: require("../images/herbs.jpg"),
  },
];



const ShopByCategory = ({ products = [] }) => {

     const { searchTerm } = useSearch();
  const [selectedCategory, setSelectedCategory] = useState("all");
   const [visibleCount, setVisibleCount] = useState(10);

const filteredProducts = useMemo(() => {
  let result =
    selectedCategory === "all"
      ? products
      : products.filter(
          (p) => (p.category || "").toLowerCase() === selectedCategory
        );

        console.log("Selected category:", selectedCategory);
console.log("Product categories:", products.map(p => p.category));


  if (searchTerm.trim() !== "") {
    result = result.filter((p) =>
      (p.name || "").toLowerCase().includes(searchTerm)
    );
  }

  return result;
}, [products, selectedCategory, searchTerm]);


   const displayedProducts = useMemo(() => {
    if (selectedCategory === "all") {
      return filteredProducts.slice(0, visibleCount);
    }
    return filteredProducts;
  }, [filteredProducts, visibleCount, selectedCategory]);


  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 10);
  };

  const activeCategoryName =
    categories.find((c) => c.id === selectedCategory)?.name || "All Products";

  return (
    <>
      <div className="category-container" id="products">
        <h2 className="category-heading">Explore Category</h2>

        <Swiper
          slidesPerView={5}
          spaceBetween={20}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          loop={true}
          pagination={{ clickable: true }}
          speed={800}
          breakpoints={{
            320: { slidesPerView: 2 },
            480: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            1024: { slidesPerView: 5 },
          }}
          modules={[Autoplay, Pagination, A11y]}
          style={{ padding: "2rem 1rem 4rem", marginBottom: "40px" }}
        >
          {categories.map((cat) => (
            <SwiperSlide key={cat.id}>
              <div className="category-item">
                <button
                  type="button"
                  className={`category-card ${
                    selectedCategory === cat.id ? "active" : ""
                  }`}
                  onClick={() => setSelectedCategory(cat.id)}
                  aria-pressed={selectedCategory === cat.id}
                  aria-label={`Filter by ${cat.name}`}
                >
                  <img src={cat.image} alt={cat.name} />
                </button>
                <div className="category-label">{cat.name}</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="container my-4 ">
        <div className="d-flex align-items-baseline justify-content-between mb-3">
          <h3 className="m-0 text-success">
            {activeCategoryName}
          </h3>
        </div>

        {displayedProducts.length === 0 ? (
          <div className="text-center text-muted py-5">
            No products found for <b>{activeCategoryName}</b>.
          </div>
        ) : (
          <>
            <div className="row g-4">
              {displayedProducts.map((product) => (
                <div
                  key={product.id}
                  className="col-12 col-sm-6 col-md-4 col-lg-3"
                >
                  <ProductCard product={product}  />
                </div>
              ))}
            </div>

            {/* Load More Button */}
            {selectedCategory === "all" &&
              visibleCount < filteredProducts.length && (
                <div className="text-center mt-4">
                  <button
                    className="btn btn-outline-success"
                    onClick={handleLoadMore}
                  >
                    Load More
                  </button>
                </div>
              )}
          </>
        )}
      </div>
    </>
  );
};

export default ShopByCategory;
